<template>
    <div class="bblist2">
        <el-card>
            <main>
                <h4 style="color:#F56C6C;font-size:14px;margin-bottom:0">
                    <span>{{ org }}</span>    
                    <van-button type="info" size="mini" @click="daoChu()">打印</van-button>
                </h4>
                <div style="margin:10px 0">
                    <van-cell title="日期" :value="date" @click="show = true" style="padding:0" />
                    <van-calendar v-model="show" type="range" @confirm="onConfirm" :min-date="minDate" />
                </div>
            </main>
            <el-table
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
				id='outTable'
                :data="list">
                <el-table-column
                    type="index"
                    fixed
                    width="50">
                </el-table-column>
                <el-table-column 
                    prop="chepai"
                    fixed
                    width="100"
                    label="车牌号">
                </el-table-column>

                <el-table-column 
                    width="140"
                    prop="time"
                    label="加油时间">
                </el-table-column>

                <el-table-column 
                    width="80"
                    prop="start1"
                    label="开始里程">
                </el-table-column>

                <el-table-column 
                    width="80"
                    prop="start2" 
                    label="结束里程">
                </el-table-column>

                <el-table-column 
                    width="80"
                    prop="start3"
                    label="行驶里程">
                </el-table-column>

                <el-table-column 
                    width="60"
                    prop="shengshu"
                    label="升数">
                </el-table-column>

                <el-table-column 
                    width="60"
                    prop="youhao"
                    label="标准">
                </el-table-column>
      
                <el-table-column 
                    width="60"
                    prop="youhao2"
                    label="实际">
                </el-table-column>

                <el-table-column 
                    width="70"
                    prop="fangshi"
                    label="方式">
                </el-table-column>


                <el-table-column label="差异" width="60">
                    <template slot-scope="scope">
                        <span>{{(scope.row.youhao2 - scope.row.youhao).toFixed(2)}}</span>
                    </template>
                </el-table-column>

                <el-table-column 
                    width="200"
                    prop="mess"
                    label="备注">
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { bblist3 } from '../router/api';

export default {
    data() {
        return {
            list: [],
            org:'',
            chepai:'',
            status:'',
            date:'',
            minDate: new Date(2023, 1, 1),
            show: false,
        };
    },
  
    mounted() {
        this.org = this.$route.query.org
        var time1 = this.$route.query.time1
        var time2 = this.$route.query.time2
        this.chepai = this.$route.query.chepai
        this.status = this.$route.query.status
        time1 = time1.split(' ')[0]
        time2 = time2.split(' ')[0]
        this.date = time1 + ' - ' + time2 
        this.getList()    
    },
    methods: {

        formatDate(date) {
            var Y = date.getFullYear() + "-"; 
            var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var day =  Y + M + D
            return day
        },

        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            this.getList()
        },


        getList() {
            this.time1 = this.date.split(' - ')[0] + ' 00:00:00'
            this.time2 = this.date.split(' - ')[1] + ' 23:59:59'
            bblist3({
                s_time: this.time1,
                e_time: this.time2,
                org:this.org,
                chepai:this.chepai,
                status:1,
            }).then(res=> {
                if(res.code==1) {
                    this.list = res.data
                }
            }).catch(err=> {
                console.log(err);
            });
        },

        daoChu() {
            var wb = XLSX.utils.table_to_book(document.querySelector('#outTable'))
            var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
            try {
                FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
            } catch(e) {
                if (typeof console !== 'undefined')
                console.log(e, wbout)
            }
            return wbout
        },
       
    },
};
</script>
<style lang="less" scoped>
.bblist2 .el-table {
    border: solid 1px black
}
.bblist2 h4 {
    display: flex;
    justify-content: space-between;
}
</style>
